import { render, staticRenderFns } from "./ProductStockNotification.vue?vue&type=template&id=dc0e4978&scoped=true&"
import script from "./ProductStockNotification.vue?vue&type=script&lang=js&"
export * from "./ProductStockNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0e4978",
  null
  
)

export default component.exports